import {
  get_dialogPageNavigator3pxggbj34kkoa as get_dialogPageNavigator,
  set_pageNavigator2t8ucpwsozusv as set_pageNavigator,
} from '../../navigation/Navigator.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../direct/SwapView.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { report1vfr9zf0i9d9p as report } from '../../debugger.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance } from '../../models/Theme.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function navigatorViewDialog(_this__u8e3s4) {
  var n = get_dialogPageNavigator(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (SwapView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  var $this$swapView = view;
  $this$swapView.db9('navigatorViewDialog');
  $this$swapView.cb9(true);
  var lastStack = {_v: n.gbn_1.f2()};
  // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
  var this_0 = $this$swapView;
  var queue = ArrayList().w();
  var alreadySwapping = {_v: false};
  reactiveScope(this_0, ($this$reactiveScope) => {
    var c = $this$reactiveScope.baj(n.hbn_1);
    queue.v(c);
    var tmp;
    if (alreadySwapping._v) {
      return Unit_instance;
    }
    alreadySwapping._v = true;
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!queue.i1()) {
        break $l$loop;
      }
      var next = queue.z3(0);
      try {
        var newStack = n.gbn_1.f2();
        var transitionSet = $this$swapView.kba().sb0_1;
        // Inline function 'kotlin.also' call
        var this_1 = (newStack.p1() - lastStack._v.p1() | 0) > 0 ? transitionSet.pbb_1 : (newStack.p1() - lastStack._v.p1() | 0) < 0 && equals(firstOrNull(newStack), firstOrNull(lastStack._v)) ? transitionSet.qbb_1 : transitionSet.rbb_1;
        lastStack._v = newStack;
        var tmp_0 = this_1;
        this_0.rci(tmp_0, navigatorViewDialog$lambda$lambda(next, n));
      } catch ($p) {
        if ($p instanceof Exception()) {
          var e = $p;
          report(Exception().vd('Failed to render ' + toString(next), e), 'SwapView.swapping');
        } else {
          throw $p;
        }
      }
    }
    alreadySwapping._v = false;
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return view;
}
function navigatorViewDialog$lambda$lambda($next, $n) {
  return ($this$swap) => {
    var screen = $next;
    // Inline function 'kotlin.with' call
    var $this$with = $this$swap.rb3();
    set_pageNavigator($this$with, $n);
    var tmp;
    if (!(screen == null)) {
      // Inline function 'kotlin.with' call
      tmp = $this$with.jbb($this$with.hbb(DialogSemantic_getInstance()), screen.ud6($this$with));
    } else {
      tmp = null;
    }
    return tmp;
  };
}
//region block: exports
export {
  navigatorViewDialog as navigatorViewDialog3c3cfw7xfbjq8,
};
//endregion

//# sourceMappingURL=NavigatorView.mjs.map
